import React, { useContext, useEffect, useState } from 'react'
import { AiFillCloseCircle } from 'react-icons/ai'
import { IoMdArrowDropdown } from 'react-icons/io'
import { IoChevronBackOutline } from 'react-icons/io5'
import { BiCheck } from 'react-icons/bi'
//agendar_admin
import Renderif from '../../components/renderif'
import DropDown, { DropDownOption } from '../../components/dropdown'
import BVCalendar from '../../components/calendar'
import { Service } from '../../services/api'
import { AuthContext } from '../../context/auth_context'

import ApiCalendar from "react-google-calendar-api";
import { AlertContext } from '../../context/alert_context'
import Loader from '../../components/loader'
const config = {
    clientId: "120251394725-odcgh221pgbild6n02k22a7qjsnls72i.apps.googleusercontent.com",
    apiKey: "AIzaSyDmACRaWHwMi8m8t3ivDh83o49N7XJS-aM",
    scope: "https://www.googleapis.com/auth/calendar",
    discoveryDocs: [
        "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest",
    ],
};
const apiCalendar = new ApiCalendar(config);

export default function AgendarAdmin({ ...props }) {
    const formatter = new Intl.DateTimeFormat('en-US', { dateStyle: 'short' });

    let date = new Date();
    date.setDate(date.getDate() + 1)

    function compare(attr, obj1, obj2) {
        return obj1[attr].localeCompare(obj2[attr]);
    }

    function generaComparador(attr) {
        return function (a, b) {
            return compare(attr, a, b);
        }
    }

    const { user } = useContext(AuthContext)
    const { notify } = useContext(AlertContext)
    const [state, setState] = useState({
        step: 0,
        selected_date: null,
        specialists: [],
        specialists_pisco: [],
        specialists_couch: [],
        selected_speciality: null,
        selected_specialist: null,
        selected_day: date,
        selected_time: '',
        selected_daytime: null,
        description: '',
        loading: false,
        clientes: [],
        available: null,
        selected_client: null,


    })
    useEffect(() => {


        const run = async () => {
            let _clientes = await Service('GET', 'User/list?pageNumber=1&pageSize=999')
            // console.log(_clientes.data.data.sort((a, b) =>a.firstName-b.firstName))
            _clientes.data.data.sort(generaComparador('firstName'))

            const psico = await Service('GET', 'Appointment/specialist/1')
            console.log(psico)
            const couch = await Service('GET', 'Appointment/specialist/2')
            console.log(couch)
            setState({ ...state, clientes: _clientes.data.data, specialists_pisco: psico.data, specialists_couch: couch.data, specialists: [...psico.data, ...couch.data] })
            // state.clientes=_clientes.data;
            // console.log(state.clientes)
        }
        run()

        return () => { }

    }, [])



    function covertLocalDateToUTC(date) {
        return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
    }

    function convertUTCDateToLocalDate(date) {
        var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
        var offset = date.getTimezoneOffset() / 60;
        var hours = date.getHours();
        newDate.setHours(hours - offset);
        return newDate;
    }

    Number.prototype.pad = function (size) {
        var s = String(this);
        while (s.length < (size || 2)) { s = "0" + s; }
        return s;
    }

    const _schedule = async () => {

        setState({ ...state, loading: true })


        try {

            //    console.log(state.selected_daytime)
            var start = new Date(state.selected_daytime);

            let end = new Date(state.selected_daytime);




            var day = start.getDate();
            var month = start.getMonth() + 1; //months are zero based
            var year = start.getFullYear();
            const time = start.toLocaleTimeString('es-ES').replace(/(.*)\D\d+/, '$1');
            let date_parsed = year + '-' + month.pad() + '-' + day.pad() + 'T' + (time.length < 5 ? "0" + time : time) + ':00.000Z';

            console.log(date_parsed);
            // console.log(state);
            // console.log(state.selected_specialist.id);
            // console.log(state.selected_client.id);

            let body = {
                userId: state.selected_client.id,
                specialistId: state.selected_specialist.id,
                date: date_parsed,
                description: state.description,
                // sessionUrl: result.result.hangoutLink
            }
            const schedule = await Service('POST', 'Appointment', body);

            if (schedule?.status === 200) {
                notify({ title: 'Listo!', message: 'Se ha agendado un nueva cita.', type: 'success' })

                let callback = {
                    dateOfEvent: start,
                    // sessionUrl: result.result.hangoutLink,
                    numberOfSession: '',
                    specialist: state.selected_specialist,
                }
                props.onSchedule(callback)

                props.onCancel()
            } else {
                notify({ title: 'Error!', message: 'No se puede agendar una cita en este momento.', type: 'error' })
                props.onCancel()
            }


            // const res = await apiCalendar.handleAuthClick();
            // if(res.access_token !== undefined){
            //     const eventWithVideoConference = {
            //         summary: "Cita Bien Vivir",
            //         start: {
            //           dateTime: start,
            //           timeZone: "America/Mexico_City",
            //         },
            //         end: {
            //           dateTime: end,
            //           timeZone: "America/Mexico_City",
            //         },
            //       };

            //       apiCalendar
            //         .createEventWithVideoConference(eventWithVideoConference)
            //         .then(async (result) => {
            //             console.log(result);

            //             let body = {
            //                 userId: state.selected_client.id,
            //                 specialistId: state.selected_specialist.id,
            //                 date: date_parsed,
            //                 description: "Cita Bien Vivir",
            //                 sessionUrl:result.result.hangoutLink
            //             }
            //             console.log(body);
            //             const schedule = await Service('POST', 'Appointment', body);

            //             if(schedule?.status === 200){
            //                 notify({title:'Listo!', message:'Se ha agendado un nueva cita.', type:'success'})

            //                 let callback = {
            //                     dateOfEvent: start,
            //                     sessionUrl:result.result.hangoutLink,
            //                     numberOfSession:'',
            //                     specialist:state.selected_specialist,  
            //                 }
            //                 props.onSchedule(callback)

            //                 props.onCancel()
            //             }else{
            //                 notify({title:'Error!', message:'No se puede agendar una cita en este momento.', type:'error'})
            //                 props.onCancel()
            //             }




            //             console.log(schedule)
            //         })
            //         .catch((error) => {
            //           console.log(error);
            //           notify({title:'Error!', message:'Al conectar con Google Calendar.', type:'error'})
            //           props.onCancel()
            //         });
            // }

        } catch (error) {
            console.log(error)
            notify({ title: 'Error!', message: 'Al conectar con Google Calendar.', type: 'error' })
        }


    }


    var arr = [
        '00:00',
        '00:30',
        '01:00',
        '01:30',
        '02:00',
        '02:30',
        '03:00',
        '03:30',
        '04:00',
        '04:30',
        '05:00',
        '05:30',
        '06:00',
        '06:30',
        '07:00',
        '07:30',
        '08:00',
        '08:30',
        '09:00',
        '09:30',
        '10:00',
        '10:30',
        '11:00',
        '11:30',
        '12:00',
        '12:30',
        '13:00',
        '13:30',
        '14:00',
        '14:30',
        '15:00',
        '15:30',
        '16:00',
        '16:30',
        '17:00',
        '17:30',
        '18:00',
        '18:30',
        '19:00',
        '19:30',
        '20:00',
        '20:30',
        '21:00',
        '21:30',
        '22:00',
        '22:30',
        '23:00',
    ]
    // var arr2 = [
    //     '03:00',
    //     '04:00',
    //     '05:00',
    //     '06:00',
    //     '07:00',
    //     '08:00',
    //     '09:00',
    //     '10:00',
    //     '11:00',
    // ]
    function ordenarAsc(p_array_json, p_key) {
        p_array_json.sort(function (a, b) {
            return a[p_key] > b[p_key];
        });
    }
    var weekday = new Array(7);
    weekday[0] = "Domingo";
    weekday[1] = "Lunes";
    weekday[2] = "Martes";
    weekday[3] = "Miercoles";
    weekday[4] = "Jueves";
    weekday[5] = "Viernes";
    weekday[6] = "Sabado";

    var months = new Array(7);
    months[0] = "Enero";
    months[1] = "Febrero";
    months[2] = "Marzo";
    months[3] = "Abril";
    months[4] = "Mayo";
    months[5] = "Junio";
    months[6] = "Julio";
    months[7] = "Agosto";
    months[8] = "Septiembre";
    months[9] = "Octubre";
    months[10] = "Noviembre";
    months[11] = "Diciembre";

    return (
        <>
            <Renderif isTrue={state.loading === true}>
                <Loader></Loader>
            </Renderif>
            <div className='overlay d-flex justify-content-center align-items-center'>
                <Renderif isTrue={state.step === 0}>
                    <div className='bv-modal shadow'>

                        <div className='px-4 pt-3 pb-4 d-flex align-items-center'>
                            <div className='f-16 text-gray'>Agendar Nueva Cita</div>
                            <div className='col'></div>
                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                props.onCancel()
                            }}> <AiFillCloseCircle size={24} color="#30B7E7"></AiFillCloseCircle></div>
                        </div>

                        <div className='px-4 pb-5'>


                            <div className='mt-2'>
                                <DropDown
                                    title='Seleccione Cliente'
                                    open={false}
                                    // defaultValue={0} 
                                    _onChange={(evt) => {
                                        console.log(evt)
                                        setState({ ...state, selected_client: evt.value })
                                    }}>


                                    {
                                        state.clientes.map((item, i) => {
                                            return (
                                                <DropDownOption key={i} value={item} label={`${item.firstName} ${item.lastName}`}>
                                                    <div className='f-14 text-gray'>{item.firstName} {item.lastName}</div>
                                                </DropDownOption>
                                            )
                                        })
                                    }
                                </DropDown>
                            </div>

                            <div className='mt-2'>
                                <DropDown
                                    title='Seleccione la Especialidad deseada (Opcional)'
                                    open={false}
                                    defaultValue={0}
                                    _onChange={(evt) => {

                                        switch (evt.value) {
                                            case 1:
                                                setState({ ...state, selected_speciality: evt, specialists: state.specialists_pisco })
                                                break;
                                            case 2:
                                                setState({ ...state, selected_speciality: evt, specialists: state.specialists_couch })
                                                break;

                                            default:
                                                setState({ ...state, selected_speciality: evt, specialists: [...state.specialists_couch, ...state.specialists_pisco] })
                                                break;
                                        }


                                    }}>
                                    <DropDownOption value={0} label="Todas Las Especialidades">
                                        <div className='f-14 text-gray'>Todas Las Especialidades</div>
                                    </DropDownOption>
                                    <DropDownOption value={1} label="Psicologia">
                                        <div className='f-14 text-gray'>Psicologia</div>
                                    </DropDownOption>
                                    <DropDownOption value={2} label="Coach">
                                        <div className='f-14 text-gray'>Coach</div>
                                    </DropDownOption>



                                </DropDown>
                            </div>

                            <div className='mt-2'>
                                <DropDown
                                    title='Seleccione el Profesional'
                                    open={false}
                                    // defaultValue={0} 
                                    _onChange={(evt) => {
                                        console.log(evt)
                                        setState({ ...state, selected_specialist: evt.value })
                                    }}>

                                    {
                                        state.specialists.map((item, i) => {
                                            return (
                                                <DropDownOption key={i} value={item} label={`${item.firstName} ${item.lastName}`}>
                                                    <div className='f-14 text-gray'>{item.firstName} {item.lastName}</div>
                                                </DropDownOption>
                                            )
                                        })
                                    }




                                </DropDown>
                            </div>








                        </div>

                        <div className='d-flex b-top p-4'>
                            <div className='col'></div>
                            <div className='bv-pill bv-pill--gray me-2 cursor-pointer' onClick={() => {
                                props.onCancel()
                            }}>Cancelar</div>
                            <div className='bv-pill bv-pill--primary cursor-pointer' onClick={async () => {
                                if (state.selected_specialist !== null) {


                                    let _available = await Service('GET', `Appointment/dates-labor/${state.selected_specialist.id}`)
                                    console.log(_available.data)
                                    var laboralDates = [];
                                    if (_available.data?.find((element) => element.dayOfWeek == "Monday")) {
                                        let row = _available.data?.find((element) => element.dayOfWeek == "Monday")
                                        row.dayOfWeek = "Lunes";
                                        laboralDates.push(row);
                                    }

                                    if (_available.data?.find((element) => element.dayOfWeek == "Tuesday")) {
                                        let row = _available.data?.find((element) => element.dayOfWeek == "Tuesday")
                                        row.dayOfWeek = "Martes";
                                        laboralDates.push(row);
                                    }
                                    if (_available.data?.find((element) => element.dayOfWeek == "Wednesday")) {
                                        let row = _available.data?.find((element) => element.dayOfWeek == "Wednesday")
                                        row.dayOfWeek = "Míercoles";
                                        laboralDates.push(row);
                                    }

                                    if (_available.data?.find((element) => element.dayOfWeek == "Thursday")) {
                                        let row = _available.data?.find((element) => element.dayOfWeek == "Thursday")
                                        row.dayOfWeek = "Jueves";
                                        laboralDates.push(row);
                                    }
                                    if (_available.data?.find((element) => element.dayOfWeek == "Friday")) {
                                        let row = _available.data?.find((element) => element.dayOfWeek == "Friday")
                                        row.dayOfWeek = "Viernes";
                                        laboralDates.push(row);
                                    }

                                    if (_available.data?.find((element) => element.dayOfWeek == "Saturday")) {
                                        let row = _available.data?.find((element) => element.dayOfWeek == "Saturday")
                                        row.dayOfWeek = "Sabado";
                                        laboralDates.push(row);
                                    }
                                    if (_available.data?.find((element) => element.dayOfWeek == "Sunday")) {
                                        let row = _available.data?.find((element) => element.dayOfWeek == "Sunday")
                                        row.dayOfWeek = "Domingo";
                                        laboralDates.push(row);
                                    }
                                    console.log(laboralDates)


                                    setState({ ...state, step: state.step + 1, available: laboralDates })
                                }
                            }}>Continuar</div>
                        </div>

                    </div>
                </Renderif>
                <Renderif isTrue={state.step === 1}>
                    <div className='bv-modal shadow'>

                        <div className='px-4 pt-3 pb-4 d-flex align-items-center'>

                            <div className='f-16 text-gray'>Agendar Nueva Cita</div>
                            <div className='col'></div>
                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                props.onCancel()
                            }}> <AiFillCloseCircle size={24} color="#30B7E7"></AiFillCloseCircle></div>
                        </div>

                        <div className='text-gray f-12 px-4 py-1'>
                            Descripcion y detalles de la cita.
                        </div>

                        <div className='px-4 pb-5'>
                            <textarea rows="4" className='input--light py-1' value={state.description} onChange={(evt) => {
                                setState({ ...state, description: evt.currentTarget.value })
                            }}></textarea>
                        </div>
                        <div className='d-flex b-top p-4'>
                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                setState({ ...state, step: state.step - 1 })
                            }}> <IoChevronBackOutline size={24} color="#30B7E7"></IoChevronBackOutline></div>
                            <div className='col'></div>
                            <div className='bv-pill bv-pill--gray me-2 cursor-pointer' onClick={() => {
                                props.onCancel()
                            }}>Cancelar</div>
                            <div className='bv-pill bv-pill--primary cursor-pointer' onClick={() => {
                                setState({ ...state, step: state.step + 1 })
                            }}>Continuar</div>
                        </div>
                    </div>
                </Renderif>
                <Renderif isTrue={state.step === 2}>
                    <div className='bv-modal shadow'>

                        <div className='px-4 pt-3 pb-4 d-flex align-items-center'>

                            <div className='f-16 text-gray'>Agendar Nueva Cita</div>
                            <div className='col'></div>
                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                props.onCancel()
                            }}> <AiFillCloseCircle size={24} color="#30B7E7"></AiFillCloseCircle></div>
                        </div>

                        <div className='text-gray f-12 px-4'>
                            Seleccione entre los dias disponibles del Medico Seleccionado para ver su agenda y escoger el horario de consulta que mas le convenga.
                        </div>


                        {/* BODY */}
                        <div className='d-flex overflow-hidden py-2 px-4'>

                            <div className='col'>
                                <BVCalendar init={date} onChange={(evt) => {
                                    // console.log(evt)
                                    // if(evt < new Date()){
                                    //     console.log("NEL")
                                    //     return;
                                    // }
                                    setState({ ...state, selected_day: evt })
                                }}></BVCalendar>
                                <div className='f-16 text-gray'>Horario laboral:</div>
                                <div className='d-flex'>
                                    {
                                        state.available?.map((item, i) => {
                                            let horario = item.timeRanges
                                            return (
                                                <div className='f-16 text-gray px-2 min-80'>{item.dayOfWeek} {
                                                    horario.map((itemh, ih) => {
                                                        return (
                                                            <div className='text-gray f-12'>{itemh.startTime.slice(0, -3)}-{itemh.endTime.slice(0, -3)}</div>
                                                        )
                                                    })
                                                }</div>
                                            )
                                        })
                                    }

                                </div>
                            </div>

                            <div className='col overflow-auto hide-scroll ps-3 d-none'>



                                {
                                    arr.map((item, i) => {

                                        return (
                                            <div key={i} className={`d-flex align-items-center py-2 b-bottom ps-1 ${state.selected_time === i ? 'highlight-active' : ''}`}>
                                                <div className='col f-12 text-gray'>{weekday[new Date(state.selected_day).getDay()]} {new Date(state.selected_day).getDate()}</div>
                                                <div className='col f-12 text-gray'>{months[new Date(state.selected_day).getMonth()]} {new Date(state.selected_day).getFullYear()}</div>
                                                <div className='col f-12 text-gray'>{item}</div>
                                                <div className={`bv-pill cursor-pointer ${state.selected_time === i ? 'bv-pill--primary' : 'bv-pill--gray'}`} onClick={() => {



                                                    let daytime = new Date(new Date(state.selected_day).setHours(item.split(':')[0], item.split(':')[1], '00'));
                                                    console.log(daytime)


                                                    setState({ ...state, selected_time: i, selected_daytime: daytime })
                                                }}>Seleccionar</div>
                                            </div>
                                        )
                                    })
                                }


                            </div>
                            <div className='col overflow-auto hide-scroll ps-3 max-height-480'>

                                <Renderif isTrue={state.selected_day < new Date(new Date().setHours(0, 0, 0, 0))}>
                                    {

                                        console.log(state.selected_day + " < " + new Date())
                                    }
                                    <div className='f-14 bold text-gray'>En BienVivir, programar citas solo es posible a partir del día siguiente.</div>
                                </Renderif>
                                {/* <Renderif isTrue={state.selected_day >= new Date(new Date().setHours(0,0,0,0))}> */}
                                <Renderif isTrue={state.selected_day >= new Date(new Date().setHours(0, 0, 0, 0))}>
                                    {
                                        arr.map((item, i) => {

                                            return (
                                                <div key={i} className={`d-flex align-items-center justify-content-center py-2 b-bottom ps-1 highlight-hover ${state.selected_time === i ? 'highlight-active' : ''}`} onClick={() => {
                                                    let daytime = new Date(new Date(state.selected_day).setHours(item.split(':')[0], item.split(':')[1], '00'));
                                                    console.log(daytime)
                                                    console.log(new Date(daytime))
                                                    setState({ ...state, selected_time: i, selected_daytime: daytime })
                                                }}>
                                                    <div className='col f-12 text-gray'>{weekday[new Date(state.selected_day).getDay()]} {new Date(state.selected_day).getDate()}</div>
                                                    <div className='col f-12 text-gray'>{months[new Date(state.selected_day).getMonth()]} {new Date(state.selected_day).getFullYear()}</div>
                                                    <div className='col f-12 text-gray'>{item}</div>
                                                    <div className='bv-icon bv-icon--mid me-2'>
                                                        <BiCheck size={28} color={`${state.selected_time === i ? '#0972CE' : 'transparent'}`}></BiCheck>
                                                    </div>
                                                    {/* <div className={`bv-pill cursor-pointer ${i === 0 ? 'bv-pill--primary':'bv-pill--gray'}`}>Seleccionar</div> */}
                                                </div>
                                            )
                                        })
                                    }
                                </Renderif>


                            </div>
                        </div>
                        {/* EDN BODY */}


                        <div className='d-flex b-top p-4'>
                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                setState({ ...state, step: state.step - 1 })
                            }}> <IoChevronBackOutline size={24} color="#30B7E7"></IoChevronBackOutline></div>
                            <div className='col'></div>
                            <div className='bv-pill bv-pill--gray me-2 cursor-pointer' onClick={() => {
                                props.onCancel()
                            }}>Cancelar</div>
                            <div className='bv-pill bv-pill--primary cursor-pointer' onClick={() => {
                                if (state.selected_daytime !== null) {
                                    setState({ ...state, step: state.step + 1 })
                                }

                            }}>Continuar</div>
                        </div>


                    </div>
                </Renderif>
                <Renderif isTrue={state.step === 3}>
                    <div className='bv-modal shadow'>

                        <div className='px-4 pt-3 pb-4 d-flex align-items-center'>
                            <div className='f-16 text-gray'>Confirmar Cita</div>
                            <div className='col'></div>
                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                props.onCancel()
                            }}> <AiFillCloseCircle size={24} color="#30B7E7"></AiFillCloseCircle></div>
                        </div>

                        <div className='px-4 pb-5'>

                            <div className='f-14 text-gray'>Su cita sera programada de la siguiente manera.</div>
                            <br></br>
                            <div className='f-14 text-black bold'>
                                {weekday[new Date(state.selected_day).getDay()]} {new Date(state.selected_day).getDate()} {months[new Date(state.selected_day).getMonth()]} {new Date(state.selected_day).getFullYear()}

                            </div>
                            <div className='f-14 text-gray'>Con <span className='text-black bold'>{state.selected_specialist?.firstName} {state.selected_specialist?.lastName} </span> en la Especialidad de: <span className='text-black bold'>{state?.selected_speciality?.label}</span>  </div>






                        </div>

                        <div className='d-flex b-top p-4'>
                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                setState({ ...state, step: state.step - 1 })
                            }}> <IoChevronBackOutline size={24} color="#30B7E7"></IoChevronBackOutline></div>
                            <div className='col'></div>
                            <div className='bv-pill bv-pill--gray me-2 cursor-pointer' onClick={() => {
                                props.onCancel()
                            }}>Cancelar</div>

                            <div className='bv-pill bv-pill--primary cursor-pointer' onClick={() => {
                                _schedule()
                            }}>Confirmar</div>
                        </div>

                    </div>
                </Renderif>
            </div>
        </>
    )
}
